import { Converter } from '../types/converter';

export const flowMolarConverter: Converter = {
  id: 'flowMolar',
  name: 'Molar Flow Converter',
  icon: 'ArrowRight',
  categories: ['engineering', 'chemistry'],
  units: [
    // Base SI unit
    { name: 'Mol/second', symbol: 'mol/s', factor: 1 },
    
    // SI prefixed units
    { name: 'Examol/second', symbol: 'Emol/s', factor: 1e18 },
    { name: 'Petamol/second', symbol: 'Pmol/s', factor: 1e15 },
    { name: 'Teramol/second', symbol: 'Tmol/s', factor: 1e12 },
    { name: 'Gigamol/second', symbol: 'Gmol/s', factor: 1e9 },
    { name: 'Megamol/second', symbol: 'Mmol/s', factor: 1e6 },
    { name: 'Kilomol/second', symbol: 'kmol/s', factor: 1e3 },
    { name: 'Hectomol/second', symbol: 'hmol/s', factor: 1e2 },
    { name: 'Dekamol/second', symbol: 'damol/s', factor: 1e1 },
    { name: 'Decimol/second', symbol: 'dmol/s', factor: 1e-1 },
    { name: 'Centimol/second', symbol: 'cmol/s', factor: 1e-2 },
    { name: 'Millimol/second', symbol: 'mmol/s', factor: 1e-3 },
    { name: 'Micromol/second', symbol: 'µmol/s', factor: 1e-6 },
    { name: 'Nanomol/second', symbol: 'nmol/s', factor: 1e-9 },
    { name: 'Picomol/second', symbol: 'pmol/s', factor: 1e-12 },
    { name: 'Femtomol/second', symbol: 'fmol/s', factor: 1e-15 },
    { name: 'Attomol/second', symbol: 'amol/s', factor: 1e-18 },
    
    // Time-based variations
    { name: 'Mol/minute', symbol: 'mol/min', factor: 0.016666667 },
    { name: 'Mol/hour', symbol: 'mol/h', factor: 0.000277778 },
    { name: 'Mol/day', symbol: 'mol/d', factor: 1.157407e-5 },
    
    // Millimol time variations
    { name: 'Millimol/minute', symbol: 'mmol/min', factor: 1.666667e-5 },
    { name: 'Millimol/hour', symbol: 'mmol/h', factor: 2.777778e-7 },
    { name: 'Millimol/day', symbol: 'mmol/d', factor: 1.157407e-8 },
    
    // Kilomol time variations
    { name: 'Kilomol/minute', symbol: 'kmol/min', factor: 16.666667 },
    { name: 'Kilomol/hour', symbol: 'kmol/h', factor: 0.277778 },
    { name: 'Kilomol/day', symbol: 'kmol/d', factor: 0.011574 }
  ]
};
